/* eslint-disable camelcase */
import { COURSE_TYPE_COACH, COURSE_TYPE_PRIVATE, COURSE_TYPE_TRAINER } from '@/constants/types';
import formatters from '@/utils/formatter';

const dtos = {
    course(course) {
        if (typeof course !== 'object') {
            return null;
        }

        const sequence = dtos.sequence(course);

        const undetermined = dtos.undetermined(course);
        const has_trainer = dtos.has_trainer(course);
        const has_coach = dtos.has_coach(course);
        const has_event = dtos.has_event(course);
        const has_program = dtos.has_program(course);

        const date_text = dtos.date_text(course);
        const periodic = dtos.periodic(course);
        const weekdays_text = dtos.weekdays_text(course);

        const user_name = dtos.user_name(course);
        const user_avatar = dtos.user_avatar(course);
        const wechat_bound = dtos.wechat_bound(course);

        const content = dtos.content(course);

        return {
            ...course,
            sequence,
            date_text,
            periodic,
            weekdays_text,
            undetermined,
            user_name,
            user_avatar,
            wechat_bound,
            content,
            has_trainer,
            has_coach,
            has_event,
            has_program,
            original: course,
        };
    },

    sequence(course) {
        const undetermined = dtos.undetermined(course);

        // 待定 0-0-
        // 约课待定 0-1-
        // 普通 1-0-
        const flags = [
            undetermined ? 0 : 1,
            (undetermined && course.draft) ? 1 : 0,
            course.start_time || `--:${course.id}`,
        ];

        return flags.join('-');
    },

    start_time_text(course) {
        return formatters.formatTime(course.start_time);
    },

    end_time_text(course) {
        return formatters.formatTime(course.end_time);
    },

    undetermined(course) {
        return !course.start_time;
    },

    periodic(course) {
        return Array.isArray(course.weekdays) && course.weekdays.length > 0;
    },

    has_trainer(course) {
        return course.type === COURSE_TYPE_TRAINER;
    },

    has_coach(course) {
        return course.type === COURSE_TYPE_COACH || course.type === COURSE_TYPE_PRIVATE;
    },

    has_event(course) {
        return course.type === COURSE_TYPE_PRIVATE;
    },

    has_program(course) {
        return course.type === COURSE_TYPE_TRAINER || course.type === COURSE_TYPE_COACH;
    },

    date_text(course) {
        const text = formatters.formatDate(course.date);
        if (dtos.periodic(course)) {
            return `${text} 起`;
        } else if (dtos.undetermined(course)) {
            return `${text}（具体时间待定）`;
        }

        return `${text} ${dtos.start_time_text(course)}`;
    },

    weekdays_text(course) {
        if (dtos.periodic(course)) {
            const text = formatters.formatWeekdays(course.weekdays);
            if (dtos.undetermined(course)) {
                return `${text}（具体时间待定）`;
            }

            return `${text} ${dtos.start_time_text(course)}`;
        }

        return null;
    },

    user_name(course) {
        if (dtos.has_trainer(course)) {
            return course.trainer && course.trainer.display_name;
        }
        if (course.type === COURSE_TYPE_COACH) {
            return '自己训练';
        }
        if (course.type === COURSE_TYPE_PRIVATE) {
            return '私人事件';
        }

        return null;
    },

    user_avatar(course) {
        if (dtos.has_trainer(course)) {
            return course.trainer && course.trainer.avatar;
        }
        if (dtos.has_coach(course)) {
            return course.coach && course.coach.avatar;
        }

        return null;
    },

    wechat_bound(course) {
        if (dtos.has_trainer(course)) {
            return course.trainer && course.trainer.wechat_bound;
        }

        return false;
    },

    content(course) {
        if (dtos.has_event(course)) {
            return course.event;
        }
        if (dtos.has_program(course)) {
            return formatters.formatPrograms(course);
        }

        return null;
    },
};

export default dtos;



// WEBPACK FOOTER //
// ./src/dtos/course.js